import { rankWith, uiTypeIs } from '@jsonforms/core'
import { FILE_UPLOADER_RENDERER_META } from './FileUploaderControl'

export default rankWith(
  5, // increase rank as needed
  uiTypeIs(FILE_UPLOADER_RENDERER_META.type)
)
